import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';

import './footerStyle.scss';

class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    /**
     * Ui elements rendering
     */
    render() {
        return (
            <Row className="footer" id="footer">
                <Col>
                    <div>
                        <p className="footer-cms-link float-left m-0 p-2">
                            <span>
                                <a href="https://cps.com/terms-of-use" target="_blank" rel="noopener noreferrer">
                                    Terms of Use{' '}
                                </a>
                                &nbsp;&nbsp;
                            </span>
                            <span>
                                <a
                                    href="https://cps.com/online-services-privacy-policy"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Privacy{' '}
                                </a>
                                &nbsp;&nbsp;
                            </span>
                            <span>
                                <a
                                    href="https://cps.com/our-technology/therigy-vista"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Contact Support
                                </a>
                            </span>
                        </p>
                        <p className="footer-copyright-box float-right m-0 p-2">
                            Copyright &#169; {new Date().getFullYear()} Therigy. All rights reserved.
                        </p>
                    </div>
                </Col>
            </Row>
        );
    }
}

export default Footer;
